import { useEffect, useState } from 'react';

interface ToastProps {
  message: string;
  isError?: boolean;
  duration?: number;
  onDismiss: () => void;
}

export function Toast({ message, isError = false, duration = 5000, onDismiss }: ToastProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!message) return;
    setVisible(true);
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onDismiss, 300);
    }, duration);
    return () => clearTimeout(timer);
  }, [message, duration, onDismiss]);

  if (!message) return null;

  return (
    <div
      className={`toast ${isError ? 'toast-error' : 'toast-success'} ${visible ? 'toast-visible' : ''}`}
      onClick={() => { setVisible(false); setTimeout(onDismiss, 300); }}
      role="status"
    >
      {message}
    </div>
  );
}
